import {Button, notification, Table, Typography} from "antd";
import renderKey from "./Output/RenderService";
import {useEffect, useState} from "react";
import {v4} from "uuid";
import ApiService from "../Service/ApiService";
import {MessageCodes} from "./Output/MessageCodes";
import RenderService from "./Output/RenderService";
import {B1} from "./Output/Internal/B1";
import {B2} from "./Output/Internal/B2";
import {B3} from "./Output/Internal/B3";
import {B4} from "./Output/Internal/B4";
import {B5} from "./Output/Internal/B5";
import {B6} from "./Output/Internal/B6";
import {B7} from "./Output/Internal/B7";
import {B9} from "./Output/Internal/B9";
import {B10} from "./Output/Internal/B10";
import {B11} from "./Output/Internal/B11";
import {B12} from "./Output/Internal/B12";
import {B13} from "./Output/Internal/B13";
import {C1} from "./Output/Compare/C1";
import {C2} from "./Output/Compare/C2";
import {C3} from "./Output/Compare/C3";
import {C4} from "./Output/Compare/C4";
import {C5} from "./Output/Compare/C5";
import {C6} from "./Output/Compare/C6";
import {C7} from "./Output/Compare/C7";
import {C8} from "./Output/Compare/C8";
import {C9} from "./Output/Compare/C9";
import {C10} from "./Output/Compare/C10";
import {C11} from "./Output/Compare/C11";
import {C12} from "./Output/Compare/C12";
import {C13} from "./Output/Compare/C13";
import {C20} from "./Output/Compare/C20";
import {C21} from "./Output/Compare/C21";
import {useUser} from "../Context/UserContext";
import MockB1 from "./Output/MockData/MockB1";
import MockB2 from "./Output/MockData/MockB2";
import MockB3 from "./Output/MockData/MockB3";
import MockB4 from "./Output/MockData/MockB4";
import MockB5 from "./Output/MockData/MockB5";
import MockB6 from "./Output/MockData/MockB6";
import MockB7 from "./Output/MockData/MockB7";
import MockB9 from "./Output/MockData/MockB9";
import MockB10 from "./Output/MockData/MockB10";
import MockB11 from "./Output/MockData/MockB11";
import MockB12 from "./Output/MockData/MockB12";
import MockB13 from "./Output/MockData/MockB13";
import MockC1 from "./Output/MockData/MockC1";
import MockC2 from "./Output/MockData/MockC2";
import MockC3 from "./Output/MockData/MockC3";
import MockC4 from "./Output/MockData/MockC4";
import MockC5 from "./Output/MockData/MockC5";
import MockC6 from "./Output/MockData/MockC6";
import MockC7 from "./Output/MockData/MockC7";
import MockC8 from "./Output/MockData/MockC8";
import MockC9 from "./Output/MockData/MockC9";
import MockC10 from "./Output/MockData/MockC10";
import MockC11 from "./Output/MockData/MockC11";
import MockC12 from "./Output/MockData/MockC12";
import MockC13 from "./Output/MockData/MockC13";
import MockC20 from "./Output/MockData/MockC20";
import MockC21 from "./Output/MockData/MockC21";
import MockB17 from "./Output/MockData/MockB17";
import MockB20 from "./Output/MockData/MockB20";
import MockB26 from "./Output/MockData/MockB26";
import MockB30 from "./Output/MockData/MockB30";
import MockB15 from "./Output/MockData/MockB15";

export default function ErrorCodesHelp() {
    const [errors, setErrors] = useState([])
    const [errorCount, setErrorCount] = useState(0)
    const {user} = useUser()

    const createHelpMessages = () => {
        let errorCodeCount = 0
        const messages = [
            {key: 'B1', data: MockB1},
            {key: 'B2', data: MockB2},
            {key: 'B3', data: MockB3},
            {key: 'B4', data: MockB4},
            {key: 'B5', data: MockB5},
            {key: 'B6', data: MockB6},
            {key: 'B7', data: MockB7},
            {key: 'B9', data: MockB9},
            {key: 'B10', data: MockB10},
            {key: 'B11', data: MockB11},
            {key: 'B12', data: MockB12},
            {key: 'B13', data: MockB13},
            {key: 'B15', data: MockB15},
            {key: 'B17', data: MockB17},
            {key: 'B20', data: MockB20},
            {key: 'B26', data: MockB26},
            {key: 'B30', data: MockB30},
            {key: 'C1', data: MockC1},
            {key: 'C2', data: MockC2},
            {key: 'C3', data: MockC3},
            {key: 'C4', data: MockC4},
            {key: 'C5', data: MockC5},
            {key: 'C6', data: MockC6},
            {key: 'C7', data: MockC7},
            {key: 'C8', data: MockC8},
            {key: 'C9', data: MockC9},
            {key: 'C10', data: MockC10},
            {key: 'C11', data: MockC11},
            {key: 'C12', data: MockC12},
            {key: 'C13', data: MockC13},
            {key: 'C20', data: MockC20},
            {key: 'C21', data: MockC21},
        ]

        let _outputs = []
        messages.forEach(m => {
            errorCodeCount += m.data.length
            _outputs.push(
                <>
                    <Typography.Title level={2}>
                        {m.key}
                    </Typography.Title>
                    {
                        RenderService.renderOutput({
                            key: m.key,
                            result: m.data,
                            report: false,
                            settings: user.settings
                        })
                    }
                    <br/>
                </>
            )
        })

        setErrorCount(errorCodeCount)
        setErrors(_outputs)
        // setErrors(data)
    }

    useEffect(() => {
        createHelpMessages()
    }, [])

    return (
        <>
            <Typography.Title level={3}>
                Total Messages: {errorCount}
            </Typography.Title>
            <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                <Button
                    size={'small'}
                    type={'primary'}
                    onClick={async () => {
                        const reportHtml = document.getElementById('report-result')
                        const res = await ApiService.Report.DownloadPDF(`<html><head></head><body style="font-family: Calibri">${reportHtml.innerHTML}</body></html>`)

                        if(res.success) {
                            const base64data = res.data;
                            var a = document.createElement("a"); //Create <a>
                            a.href = 'data:application/text;base64,'+base64data; //Image Base64 Goes here
                            a.download = `Report.pdf`; //File name Here
                            a.click(); //Downloaded file
                        }
                    }}
                >
                    Download PDF
                </Button>
                <Button
                    size={'small'}
                    type={'primary'}
                    onClick={async () => {
                        const reportHtml = document.getElementById('report-result')
                        const res = await ApiService.Report.DownloadWord(`<html><head></head><body style="font-family: Calibri">${reportHtml.innerHTML}</body></html>`)

                        if(res.success) {
                            const base64data = res.data;
                            var a = document.createElement("a"); //Create <a>
                            a.href = 'data:application/text;base64,'+base64data; //Image Base64 Goes here
                            a.download = `Report.docx`; //File name Here
                            a.click(); //Downloaded file
                        }
                    }}
                >
                    Download Word
                </Button>
                <Button
                    size={'small'}
                    type={'primary'}
                    onClick={async () => {
                        const elTable = document.getElementById('report-result')

                        let range, sel;

                        if (document.createRange && window.getSelection) {
                            elTable.style.fontFamily = "Calibri";
                            range = document.createRange();
                            sel = window.getSelection();
                            // unselect any element in the page
                            sel.removeAllRanges();

                            try {
                                range.selectNodeContents(elTable);
                                sel.addRange(range);
                            } catch (e) {
                                range.selectNode(elTable);
                                sel.addRange(range);
                            }

                            document.execCommand('copy');

                            notification.success({
                                message: 'Result Copied!'
                            })
                        }

                        sel.removeAllRanges();
                    }}
                >
                    Copy
                </Button>
            </div>
            <br/>
            <div id={'report-result'}>
                {errors}
            </div>
        </>
    )
}